<template>
    <div class="home">


        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Badges/Tags</h5>

            <br class="no-move"/>

        </div>

        <div class="main-title">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="headers-text text-dark"><strong>Das System erklärt</strong></h1>
            <p class="body-title-lighter text-dark container"><strong>In den Einstellungen kannst du deine Badges personalisieren. Du kannst sie auf eine bestimmte Seite setzen oder deaktivieren. Diese Änderungen sind für jeden LabyHelp Spieler sichtbar.</strong></p>
            <br class="no-move"/>
            <br class="no-move"/>
            <h1 class="headers-text text-dark"><strong>Badges erhalten</strong></h1>
            <p class="body-title-lighter text-dark container"><strong>Du erhältst Badges, indem du im größten Teil verschiedene temporäre oder permanenten Challenges absolvierst.</strong></p>
            <br class="no-move"/>
            <br class="no-move"/>
            <h1 class="headers-text text-dark"><strong>Permanente Badges</strong></h1>
            <p class="body-title-lighter text-dark container"><strong>Alle Badges sind permanent, du kannst die meisten aber nur in einer begrenzten Zeit für deinen Account einlösen (zum Beispiel das Ostern 2021 Badge was nur in der Oster Zeit verfügbar war). Was du dir immer abholen kannst ist das Discord Badge
                (<a href="https://discord.com/channels/736693312278233170/736693312781811785/812000440652005417" target="_blank">Weitere Informationen auf unserem Discord</a>).</strong></p>
            <br class="no-move"/>


            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{today.getFullYear()}}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                        -
                        <a style="color: #6868b3"
                           href="https://discord.gg/eX6g3zD">Discord</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>